module.exports = __webpack_public_path__ + "img/corner_icon_try.364f9d70.png";